<template>
  <Modal v-model="visible" title="编辑身份信息" width="500" footer-hide>
    <Alert type="error" show-icon>
      <p class="text-paragraph text-bold">请务必填写您本人真实有效的身份信息，信息一旦提交均不可再次修改！</p>
      <Icon type="ios-bulb-outline" slot="icon"></Icon>
      <template slot="desc">
        <p class="text-paragraph text-indent">1、请务必保证填写您本人真实且有效的身份信息，如因填写信息错误导致证书发放与寄送失败或出现错误，所有责任由您本人承担；</p>
        <p class="text-paragraph text-indent">2、请勿盗用他人信息，如发现该情况，将会撤销您已经获得的所有证书，且所有责任由您本人承担。</p>
      </template>
    </Alert>

    <Form class="form" ref="$form" :label-width="100" :model="userInfo" :rules="rules">
      <FormItem label="真实姓名：" prop="realName">
        <Input v-model="userInfo.realName" :disabled="disabled" :maxlength="15" placeholder="请填写真实姓名" />
      </FormItem>
      <FormItem label="身份证号：" prop="idCardSeriesNo">
        <Input v-model="userInfo.idCardSeriesNo" :disabled="disabled" :maxlength="18" placeholder="请填写身份证号" />
      </FormItem>
      <FormItem label="性别选择：" prop="sex">
        <Select v-model="userInfo.sex" :disabled="disabled" placeholder="请选择您的性别">
          <Option v-for="item in SEX_TYPE" :key="item.value" :value="item.value">{{ item.label }}</Option>
        </Select>
      </FormItem>
      <FormItem label="教育水平：" prop="education">
        <Select v-model="userInfo.education" :disabled="disabled" placeholder="请选择教育水平">
          <Option v-for="item in EDUCATION_TYPE" :key="item.value" :value="item.value">{{ item.label }}</Option>
        </Select>
      </FormItem>
    </Form>

    <Button type="primary" long v-if="!disabled" @click="handleSubmitInfo">提交我的信息</Button>
  </Modal>
</template>

<script>
import { mapActions } from 'vuex'
import { EDUCATION_TYPE, SEX_TYPE, getLabelByValue } from '../../../libs/constant'
import { idCardValidator } from '../../../libs/validator'
import { USER } from '../../../libs/namespace'

export default {
  data () {
    return {
      userInfo: {
        realName: '',
        idCardSeriesNo: '',
        sex: '',
        education: ''
      },
      rules: {
        realName: [
          { required: true, message: '请填写真实姓名', trigger: 'blur' }
        ],
        idCardSeriesNo: [
          { required: true, message: '请填写身份证号', trigger: 'blur' },
          { validator: idCardValidator, trigger: 'blur' }
        ],
        sex: [
          { required: true, message: '请选择您的性别', trigger: 'change' }
        ],
        education: [
          { required: true, message: '请选择教育水平', trigger: 'change' }
        ]
      },
      disabled: false,
      EDUCATION_TYPE,
      SEX_TYPE
    }
  },
  // created () {
  //   this.initUserInfo()
  // },
  handlers: {
    async handleSubmitInfo () {
      if (!(await this.$refs.$form.validate())) return
      const flag = await window.confirm({
        title: '请再次确认您的信息是否正确',
        content: `
          <p class="text-paragraph">真实姓名：${this.userInfo.realName}</p>
          <p class="text-paragraph">身份证号：${this.userInfo.idCardSeriesNo}</p>
          <p class="text-paragraph">您的性别：${getLabelByValue(this.userInfo.sex, SEX_TYPE)}</p>
          <p class="text-paragraph">教育水平：${getLabelByValue(this.userInfo.education, EDUCATION_TYPE)}</p>
        `,
        loading: true
      })
      if (flag) {
        let info = Object.assign({}, this.userInfo)
        info.sex = Number(info.sex)
        info.education = Number(info.education)
        await this.updateUser(info)
        window.toast.success('提交成功')
        this.visible = false
      }
    }
  },
  methods: {
    ...mapActions(USER, [ 'updateUser' ]),

    initUserInfo () {
      const info = this.$store.state.user.userInfo
      for (let key in this.userInfo) {
        if (info[key]) {
          this.userInfo[key] = info[key].toString()
          this.disabled = true
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.form {
  padding-right: 20px;
  margin-top: 20px;
}
</style>

